import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

/* PIPES */
import { PromptValuePipe } from './pipes/promptValue.pipe'

@NgModule({
    imports: [BrowserModule],
    declarations: [PromptValuePipe],
    exports: [PromptValuePipe],
    providers: []
})
export class GlobalServicesModule { }
